import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { TimeSlotsQuery } from "../../../graphql/deliveryService/queries/timeSlots";
import { TimeSlotFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface useTimeSlotsQueryProps {
  dataAction: (data: TimeSlotFragment[]) => void;
  errorAction?: () => void;
}

const useTimeSlotsQuery = (props: useTimeSlotsQueryProps) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const query = useLazyQuery(TimeSlotsQuery, { fetchPolicy: "network-only" });

  const { data, error } = query[1];

  const timeSlotsFragment = data?.timeSlots;

  useEffect(() => {
    if (!error) return;

    handleError(t("timeSlotsError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !timeSlotsFragment) return;

    dataAction(timeSlotsFragment);
  }, [data]);

  return query;
};

export default useTimeSlotsQuery;
